// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth__Jwt from "./Auth__Jwt.res.js";
import * as Auth__Http from "./Auth__Http.res.js";
import * as Auth__Hooks from "./Auth__Hooks.res.js";
import * as Auth__Context from "./Auth__Context.res.js";
import * as Auth__Elements from "./Auth__Elements.res.js";
import * as Auth__Permissions from "./Auth__Permissions.res.js";

let ShopKind;

let SelectShopFilter = Auth__Elements.SelectShopFilter;

let SelectSingleShopFilter = Auth__Elements.SelectSingleShopFilter;

let InputSelectSingleShopField = Auth__Elements.InputSelectSingleShopField;

let Provider = Auth__Context.Provider;

let encodeHttpContext = Auth__Http.encodeHttpContext;

let getJwt = Auth__Jwt.get;

let removeJwt = Auth__Jwt.remove;

let hasCavavinPermission = Auth__Permissions.hasCavavinPermission;

let isAuthorizedAccess = Auth__Permissions.isAuthorizedAccess;

let useRole = Auth__Permissions.useRole;

let useLogUser = Auth__Hooks.useLogUser;

let useUnlogUser = Auth__Hooks.useUnlogUser;

let useState = Auth__Hooks.useState;

let useDispatch = Auth__Hooks.useDispatch;

let useShops = Auth__Hooks.useShops;

let useActiveShop = Auth__Hooks.useActiveShop;

let useActiveShopExn = Auth__Hooks.useActiveShopExn;

let useScope = Auth__Hooks.useScope;

export {
  ShopKind,
  SelectShopFilter,
  SelectSingleShopFilter,
  InputSelectSingleShopField,
  Provider,
  encodeHttpContext,
  getJwt,
  removeJwt,
  hasCavavinPermission,
  isAuthorizedAccess,
  useRole,
  useLogUser,
  useUnlogUser,
  useState,
  useDispatch,
  useShops,
  useActiveShop,
  useActiveShopExn,
  useScope,
}
/* Auth__Jwt Not a pure module */
